// import $ from 'jquery';
import React, { createRef } from 'react';
import Field from './Field';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import ReactLoading from 'react-loading';
import { axiosUploadImages } from '../../actions/imageActions';
import { createAlert } from '../../dom/window';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
// import PropTypes from 'prop-types';

class FieldDropzone extends Field {
    constructor(props) {
        super(props);

        this.dropzoneRef = this.props.fieldRef || createRef();

        this.state = {
            isUploading: false,
            acceptedFiles: [],
            rejectedFiles: [],
        };

        this.onDrop = this.onDrop.bind(this);
        this.openFileDialog = this.openFileDialog.bind(this);
    }
    // format(value) {
    // }
    // validate() {
    // }
    handleClasses() {
        const { isUploading } = this.state;
        return super
            .handleClasses()
            .concat(
                ` field--dropzone ${isUploading === true &&
                    'field--dropzone--loading'}`
            );
    }
    getAcceptedTypes() {
        let types = [];
        const { allowImages } = this.props;

        if (typeof allowImages != 'undefined' && allowImages === true) {
            types = [...types, 'image/*'];
        }

        return types.join(',');
    }
    onRemoveExistingImage(file, index) {
        const { onRemoveExistingImage } = this.props;

        if (
            typeof onRemoveExistingImage != 'undefined' &&
            onRemoveExistingImage
        ) {
            onRemoveExistingImage(file, index);
        }
    }
    onRemoveDropzoneItem(e, file, index) {
        e.stopPropagation();

        const { onRemoveDropzoneItem } = this.props;

        const { acceptedFiles } = this.state;

        acceptedFiles.splice(index, 1);

        this.setState({
            acceptedFiles: acceptedFiles,
        });

        if (onRemoveDropzoneItem) {
            onRemoveDropzoneItem(acceptedFiles);
        }
    }
    setPreview(uploadedFiles) {
        return uploadedFiles.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
            })
        );
    }
    async onDrop(accepted, rejected) {
        let validationStatus = true;
        const {
            availableFiles = [],
            maxFiles,
            onFileUpload = false,
            onSuccessfulUpload,
            onRemoveExistingImage,
            maxSize,
        } = this.props;
        const { acceptedFiles, rejectedFiles } = this.state;
        const totalNewFiles = accepted.length;
        const isFileTooLarge =
            typeof maxSize != 'undefined' && maxSize
                ? rejected.length > 0 && rejected[0].size > maxSize
                : false;

        this.setPreview(accepted);
        this.setPreview(rejected);

        let newAcceptedFiles = [...acceptedFiles, ...accepted];
        let newRejectedFiles = [...rejectedFiles, ...rejected];

        if (typeof maxFiles != 'undefined') {
            validationStatus =
                newAcceptedFiles.length + availableFiles.length <= maxFiles;
        }

        // Remove the old one
        if (!validationStatus) {
            let totalExistingRemoved = 0;
            if (availableFiles.length > 0) {
                availableFiles.map((availableFile, index) => {
                    if (totalExistingRemoved < totalNewFiles) {
                        onRemoveExistingImage(availableFile, index);
                        totalExistingRemoved++;
                    }
                });
            }

            const leftOverToBeRemoved = totalNewFiles - totalExistingRemoved;
            if (leftOverToBeRemoved > 0) {
                newAcceptedFiles = newAcceptedFiles.slice(leftOverToBeRemoved);
            }
        }

        if (newAcceptedFiles.length) {
            this.setState({ isUploading: true });

            const axiosCall = onFileUpload ? onFileUpload : axiosUploadImages;

            await axiosCall(newAcceptedFiles).then((response) => {
                if (response) {
                    const { data } = response;
                    if (typeof data.ID != 'undefined') {
                        onSuccessfulUpload(response);

                        this.setState({
                            acceptedFiles: newAcceptedFiles,
                            rejectedFiles: newRejectedFiles,
                        });
                    } else {
                        if (typeof data.message != 'undefined') {
                            createAlert(data, 'error');
                        }
                    }
                }
            });

            this.setState({isUploading: false});

        } else if (isFileTooLarge) {
            createAlert(
                {
                    message: getTranslation(
                        'FILE_UPLOAD.MAX_FILE_SIZE_EXCEEDED'
                    ).replace('{size}', Math.round(maxSize / 1048576) + 'MB'),
                },
                'error'
            );
        }
    }
    openFileDialog() {
        if (this.dropzoneRef.current) {
            this.dropzoneRef.current.open();
        }
    }
    render() {
        const { availableFiles = [], minSize, maxSize, alternativeExplanation = null } = this.props;
        const { acceptedFiles = [], isUploading } = this.state;
        const hasFiles = acceptedFiles.length > 0 || availableFiles.length > 0;
        const showInstruction = !hasFiles;
        const hasMaxSize = typeof maxSize != 'undefined' && maxSize > 0;
        const maxSizeInMB = hasMaxSize ? Math.floor(maxSize / 1048576) : null;

        return (
            <React.Fragment>
                <span className={this.handleClasses()}>
                    {isUploading === true && (
                        <div className='field__dropzone-loading'>
                            <ReactLoading
                                type='spin'
                                color='black'
                                height={25}
                                width={25}
                            />
                        </div>
                    )}
                    {super.renderLabel()}
                    <Dropzone
                        ref={this.dropzoneRef}
                        className='form-photos form-photos--inside'
                        accept={this.getAcceptedTypes()}
                        onDrop={this.onDrop}
                        minSize={minSize}
                        maxSize={maxSize}
                    >
                        {({
                            getRootProps,
                            getInputProps,
                            open,
                            isDragActive,
                        }) => {
                            return (
                                <div
                                    {...getRootProps()}
                                    className={classNames('dropzone', {
                                        'dropzone--isActive': isDragActive,
                                    })}
                                >
                                    <input {...getInputProps()} />
                                    {showInstruction === true && (
                                        <div className='field__dropzone-explanation field__dropzone-explanation--bigger'>
                                            <span className='field__dropzone-explanation__image'>
                                                <span className='icon icon-image' />
                                            </span>
                                            <span className='field__dropzone-explanation__big-text'>
                                                {isDragActive ? (
                                                    <LocalizedMessage id={'FILE_UPLOAD.DROP_FILE_HERE'} />
                                                ) : (
                                                    <>
                                                        {alternativeExplanation ?
                                                            alternativeExplanation
                                                            :
                                                            <LocalizedMessage id={'FILE_UPLOAD.DRAG_IMAGE_TO_UPLOAD'} />
                                                        }
                                                    </>
                                                )}
                                            </span>
                                            <span
                                                className='field__dropzone-explanation__small-text'
                                                dangerouslySetInnerHTML={{
                                                    __html: getTranslation(
                                                        'FILE_UPLOAD.BROWSE_YOUR_COMPUTER'
                                                    ),
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className='form-photos form-photos--inside'>
                                        {availableFiles.map((file, index) => {
                                            return (
                                                <div
                                                    className='form-photos-template'
                                                    key={index}
                                                >
                                                    <div className='form-photos__item'>
                                                        <div className='dz-preview dz-file-preview'>
                                                            <div className='dz-details'>
                                                                <img
                                                                    src={
                                                                        file.preview
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                className='dz-remove'
                                                                onClick={(e) =>
                                                                    this.onRemoveExistingImage(
                                                                        file,
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                <i className='icon icon-close' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {acceptedFiles.map((file, index) => {
                                            return (
                                                <div
                                                    className='form-photos-template'
                                                    key={file.name}
                                                >
                                                    <div className='form-photos__item'>
                                                        <div className='dz-preview dz-file-preview'>
                                                            <div className='dz-details'>
                                                                <img
                                                                    src={
                                                                        file.preview
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                className='dz-remove'
                                                                onClick={(e) =>
                                                                    this.onRemoveDropzoneItem(
                                                                        e,
                                                                        file,
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                <i className='icon icon-close' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        }}
                    </Dropzone>
                    {super.renderError()}
                    {super.renderLoading()}
                    {(hasFiles === true || hasMaxSize) && (
                        <span
                            className='field__dropzone__mini-text'
                            onClick={this.openFileDialog}
                        >
                            {hasFiles === true && (
                                <React.Fragment>
                                    <div
                                        style={{ display: 'inline-block' }}
                                        dangerouslySetInnerHTML={{
                                            __html: getTranslation(
                                                'FILE_UPLOAD.REPLACE_THIS_IMAGE'
                                            ),
                                        }}
                                    />{' '}
                                </React.Fragment>
                            )}
                            {hasMaxSize === true && (
                                <React.Fragment>
                                    <strong>
                                        <LocalizedMessage
                                            id={
                                                'FILE_UPLOAD.MAX_FILE_SIZE_INSTRUCTIONS'
                                            }
                                            maxSizeInMB={maxSizeInMB}
                                        />
                                    </strong>
                                </React.Fragment>
                            )}
                        </span>
                    )}
                </span>
            </React.Fragment>
        );
    }
}

export default FieldDropzone;
